import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'kam-expense/panel',
    onEnter: '',
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const kamExpense = require('./containers/kamExpense').default;
        cb(null, kamExpense)
      }, 'offer')
    }
  })
}

// isLoggedIn(store)


// WEBPACK FOOTER //
// ./src/routes/KamExpenses/index.js